// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__10Zac","title":"BackImages_title__2DXyK","images":"BackImages_images__OUX3g"};